import error from '@/routes/utilities/error'
import main from '@/routes/public/main'
import utility from '@/routes/utilities/utility'

const routes = [...error, ...main, ...utility]

export default routes
